import { RULES_ROOT_STORE_PATH } from './constants'
import { addNamespace } from '@/store/helpers'

// To be used only inside vuex modules
export const _mutations = {
  SET_PROJECTS: 'setProjects',
  SET_PACKAGES: 'setPackages',
  RESET_PROJECTS: 'resetProjects',
  RESET_PACKAGES: 'resetPackages',
  SET_CATALOG: 'setCatalog',
  RESET_CATALOG: 'resetCatalog',
  UPDATE_ACTIVE_PROJECT: 'updateActiveProject',
  OPEN_COMMIT_CHANGES_DIALOG: 'openCommitChangesDialog',
  CLOSE_COMMIT_CHANGES_DIALOG: 'closeCommitChangesDialog',
  START_LOADING_UNCOMMITTED_COMPONENTS: 'startLoadingUncommittedComponents',
  STOP_LOADING_UNCOMMITTED_COMPONENTS: 'stopLoadingUncommittedComponents',
  RESET_UNCOMMITTED_COMPONENTS: 'resetUncommittedComponents',
  SET_UNCOMMITTED_COMPONENTS_LOADED: 'setUncommittedComponentsLoaded',
  SET_UNCOMMITTED_COMPONENTS: 'setUncommittedComponentsLoading',
  SET_UNCOMMITTED_COMPONENTS_ERROR: 'setUncommittedComponentsError',
  OPEN_PROJECT_DEPLOYMENT_DIALOG: 'openProjectDeploymentDialog',
  CLOSE_PROJECT_DEPLOYMENT_DIALOG: 'closeProjectDeploymentDialog',
}

// To be used publicly outside vuex modules
export const MUTATIONS = addNamespace(
  RULES_ROOT_STORE_PATH,
  _mutations
)
